import { useMedia } from 'react-use';
import { type Customer } from '@hungryroot/rest';
import { BreakpointQueryLarge } from '@hungryroot/tokens';

import {
  SaveRecipes,
  Variant as SaveVariant,
} from '../../SaveRecipes/SaveRecipes';
import { type Props as RDPPRops } from '../RDP/RDP';
import styles from './FavoriteButton.module.css';

type Props = Pick<RDPPRops, 'pairing'> & { customer: Customer };

export function FavoriteButton(props: Props) {
  const { pairing, customer } = props;
  const isDesktop = useMedia(BreakpointQueryLarge);
  const { name: pairingName, id: pairingId } = pairing;

  return (
    <SaveRecipes
      pairingName={pairingName}
      className={styles.save}
      variant={isDesktop === true ? SaveVariant.Card : SaveVariant.RDP}
      pairingId={pairingId}
      segment={{
        location: 'RDP',
        path: 'congrats',
      }}
      testid="rdp-save"
      customer={customer}
    />
  );
}
